module.exports = __webpack_public_path__ + "media/Images/icon-list-to-go-o-28befde2ac7360160d053678d63404d1.svg";